'use client'

import Header from '@/components/header/Header'
import React, { useEffect } from 'react'
// import logoMain from '@/assets/img/logo-main.svg'
import logoMain from '@/assets/img/dark-vers.svg'
import FullProdSlider from '@/components/catalog/FullProdSlider'
import MainOrder from '@/components/main/MainOrder'
import NewsBanner from '@/components/news/NewsBanner'
import Link from 'next/link'
import MediaSlider from '@/components/MediaSlider'
import OurArticles from '@/components/OurArticles'
import Footer from '@/components/Footer/Footer'
import MainSliderChapters from '@/components/main/MainSliderChapters'
import { useGetAllExternalLinksQuery } from '@/redux/services/externalLinksApi'
import { useGetAllAnimalTypesQuery } from '@/redux/services/admin/animalTypesApi'
import { useDispatch } from 'react-redux'
import { setResetCatalogFilters, setResetMaterialsFilters, setResetNewsFilters } from '@/redux/features/filterSlice'
import MainSceneWithWrapper from '@/components/MainSceneWithWrapper/MainSceneWithWrapper'
import CardSlider from '@/components/CardSlider'
import { useTranslation } from 'react-i18next'
import Megaschool from '@/components/Megaschool/Megaschool'
import { useGetAllNewsQuery, useGetExhibitionsQuery } from '@/redux/services/newsApi'

const headSliderList = ['миссия', 'новости', 'статьи', 'мегамикс']

const cardSlideItem = {
    page: 'media',
    items: [
        {
            title: 'Иностранным партнерам',
            text: [
                'Описание, что вы найдете в этом разделе: идейные соображения высшего порядка, а также начало повседневной работы по формированию позиции позволяет оценить значение направлений прогрессивного развития.',
                'С другой стороны консультация с широким активом способствует подготовки и реализации дальнейших направлений развития. Товарищи! сложившаяся структура организации требуют от нас анализа позиций, занимаемых участниками в отношении поставленных задач.'
            ],
            cardClass: 'product__slide'
        }
    ],
    btn: {
        content: 'Подробнее',
        link: '#order',
        icon: 'details'
    }
}

const data_static = {
    tag: 'партнерам',
    title: 'Экспорт',
    text: 'Свяжитесь с нашими менеджерами, чтобы получить консультацию, оформить заказ или обсудить сотрудничество. Мы сопровождаем партнеров на всех этапах работы — от оформления документов до логистики.',
    btnText: 'Связаться'
}

const propsdata = [
    {
        title: 'Мамонов<br/>Никита',
        author: [
            {
                name: 'Руководитель службы экспорта',
                post: '+79375531077, mamonov.n@megamix.ru '
            }
        ],
        image: 'b33bd1d4a20cdf21ac11c059cfdcdea3.png'
    },
    {
        title: ' Куликов<br/> Сергей',
        author: [
            {
                name: 'Главный региональный менеджер',
                post: '+79375630890, kulikov.s@megamix.ru'
            }
        ],
        image: 'c46d685bcbe10877921e85485d08dd585.png'
    }
]

const ImportModule = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const cardItem = {
        page: 'media',
        items: {
            tag: t('exportLower'),
            title: t('to_foreign_partners'),
            text: [
                t('MEGAMIX_Group_actively_develops_a_global_dealer_network'),
                t('today_we_are_already_successfully_working'),
                t('our_services_for_international_partners_include')
            ]
        }
    }

    useEffect(() => {
        dispatch(setResetNewsFilters())
        dispatch(setResetMaterialsFilters())
        dispatch(setResetCatalogFilters())
    }, [])

    const { data: data } = useGetAllExternalLinksQuery()
    const { data: news } = useGetExhibitionsQuery()
    const { data: animalTypes } = useGetAllAnimalTypesQuery()

    return (
        <main className='main import'>
            {/* <div className="home__light-blue"></div>
            <div className="home__purple-1"></div>
            <div className="home__purple-2"></div>
            <div className="home__violet"></div> */}
            <Header burgerBg='linear-gradient(180deg, #3156A8 21.87%, #2D3079 108.55%)' />
            <MainSceneWithWrapper
                zInx={-1}
                bottomBlur
            />
            <div className='container'>
                <div className='media__top import__top'>
                    <Link href={'/#map-cards'}>
                        <button className='buttons buttons__maps'>
                            <svg
                                width='19'
                                height='19'
                                viewBox='0 0 19 19'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <g opacity='0.6'>
                                    <path
                                        d='M1 3.34483L5.95833 1V15.6552L1 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                    <path
                                        d='M12.3334 3.34483L18 1V15.6552L12.3334 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                    <path
                                        d='M12.3334 3.34483L5.95837 1V15.6552L12.3334 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                </g>
                            </svg>
                            {t('BackToMap')}
                        </button>
                    </Link>
                    {/* <FullProdSlider
                        list={cardSlideItem}
                        page='import'
                        link='/'
                        headSlider={headSliderList}
                    /> */}
                    <MainOrder
                        item={cardItem.items}
                        link1={'/'}
                        btnContent={t('contact_the_manager')}
                    />
                    {/* <div style={{ opacity: 0, zIndex: -10 }}>
                        <CardSlider
                            list={cardSlideItem}
                            headSlider={headSliderList}
                        />
                    </div> */}
                </div>
            </div>
            {animalTypes && <MainSliderChapters list={animalTypes} />}
            <div
                className='container'
                style={{ marginTop: 150 }}
            >
                <Megaschool
                    type='managers'
                    staticpropsdata={data_static}
                    propsdata={propsdata}
                    sendManager={{
                        photo: propsdata[0].image,
                        post: propsdata[0].author[0]?.name,
                        name: propsdata[0].title,
                        id: 1,
                        email: propsdata[0].author[0]?.post
                    }}
                />
            </div>
            <div className='container'>
                {/* <MainOrder
                    item={cardItem.items}
                    link1={'/'}
                    btnContent='Связаться с менеджером'
                /> */}
                <div className='news__section'>
                    <h2 className='main__section-title'>Выставки и встречи</h2>
                    <Link
                        href='/news'
                        className='useful-materials__link'
                    >
                        <p>{t('watchAll')}</p>
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                                stroke='#83A3EB'
                                strokeWidth='2'
                                strokeLinecap='round'
                            />
                        </svg>
                    </Link>
                    {news && <NewsBanner existedData={news.slice(0, 6)}/>}
                    
                </div>
            </div>
            <div className='container'>
                <OurArticles />
            </div>
            <Footer />
        </main>
    )
}

export default ImportModule
